export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_PERMISSIONS = 'AUTH_PERMISSIONS'

/*

### Permissions

** Implemented **:
  add_project
  add_submission

  change_analysis
  change_project
  change_application

** Not Implemented **
  change_customfield

  change_experiment
  change_individual
  change_submission

** Not Aplicable in Frontend **
  change_assembly
  change_center
  change_disease
  change_technique
  change_platform

  delete_analysis
  delete_application
  delete_assembly
  delete_center
  delete_customfield
  delete_disease
  delete_experiment
  delete_individual
  delete_platform
  delete_project
  delete_submission
  delete_technique

  add_analysis
  add_application
  add_assembly
  add_center
  add_customfield
  add_disease
  add_experiment
  add_individual
  add_platform
  add_technique
*/
